module.exports = __webpack_public_path__ + "static/media/patrol(27).198d56de.PNG";